import React, {useState,useEffect } from 'react';
import { Container} from "reactstrap";
//Import Breadcrumb
import _ from 'lodash'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { getUserBusinessList } from "../../services/api/api-service";
import List from './userComponents/list';
const MtgpsUserList = (props) => {
    const [userListData, setUserListData] = useState([]);
    useEffect(() => {
        getUserBusinessList("MTGPS").then(data => {
            if (!_.isEmpty(data)) {
                setUserListData(data);
                //console.log(data);
            }
        })
    }, [])
    return (
        <>
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        {/* Render Breadcrumbs */}
                        <Breadcrumbs title="Regester User" breadcrumbItem="User List" />
                          <List title={'MoversTrip GPS User List'} listData={userListData} userlists={setUserListData} userFilterType="MTGPS"/>
                    </Container>
                </div>
            </React.Fragment>
        </>
    );
}
export default MtgpsUserList;